"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_TYPE_SAMPLE = exports.USER_TYPE_RENEWAL = exports.USER_TYPE_PARTNERSHIP = exports.USER_TYPE_INITIAL = void 0;
var USER_TYPE_PARTNERSHIP = exports.USER_TYPE_PARTNERSHIP = 'partnerships';
var USER_TYPE_INITIAL = exports.USER_TYPE_INITIAL = 'prepaid';
var USER_TYPE_RENEWAL = exports.USER_TYPE_RENEWAL = 'renewal';
var USER_TYPE_SAMPLE = exports.USER_TYPE_SAMPLE = 'sample';